import React from 'react';
import { Box, FormLabel } from '@chakra-ui/core';

interface FloatingFieldProps {
  label: string;
  shouldFloat: boolean;
  children: React.ReactNode;
  htmlLabel: string;
}

export const CustomFloatingField = ({ label, shouldFloat, children, htmlLabel }: FloatingFieldProps): JSX.Element => (
  <Box position="relative" width="100%">
    <FormLabel
      htmlFor={htmlLabel}
      position="absolute"
      left="12px"
      px="4px"
      pointerEvents="none"
      zIndex={2}
      top={shouldFloat ? '15px' : '50%'}
      transform={shouldFloat ? 'translateY(-50%) scale(0.85)' : 'translateY(-50%)'}
      transformOrigin="left top"
      fontSize={shouldFloat ? '14px' : '15px'}
      color={shouldFloat ? 'gray.800' : 'gray.500'}
      transition="all 0.2s ease"
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
      maxWidth="calc(100% - 24px)"
    >
      {label}
    </FormLabel>
    {children}
  </Box>
);
